<template>
  <div class="page repayment-detail">
    <navigation customClickEvent @click="hanldeBack">账单详情</navigation>

    <div class="repayment-info">
      <nd-cell
        class="repayment-info-item"
        :arrow="false"
        title="账单金额 (元)"
      >
        <span slot="text">{{ detail.schdLoanServFee | currency }}</span>
      </nd-cell>

      <nd-cell
        class="repayment-info-item"
        :arrow="false"
        title="账单生效日"
      >
        <span slot="text">{{
          detail.lendingDate | date('YYYY/MM/DD')
        }}</span>
      </nd-cell>
    </div>
    <div class="repayment-schedule">
      <div class="cell-title">
        支付计划<em>（共{{ scheduleList.length }}期）</em>
      </div>

      <div class="schedule-list">
        <table>
          <tr class="table-header">
            <th >支付日</th>
            <th >期数</th>
            <th >应付金额</th>
            <th >实付金额</th>
            <th >状态</th>
          </tr>
          <tr
            class="table-row"
            :class="[
              item.rightRepayStatus.toLowerCase(),
              termNo === item.termNo && 'now',
            ]"
            v-for="(item, index) in scheduleList"
            :key="index"
          >
            <td>
              {{ item.pmtDueDate | date('YYYY/MM/DD') }}
            </td>
            <td>
              {{ item.termNo }}/{{ scheduleList.length }}
            </td>
            <td >￥{{ item.schdLoanServFee | currency }}</td> 
            <td >￥{{ item.paidLoanServFee | currency }}</td> 
            
            <td>{{ item.rightRepayStatus | status }}</td>
          </tr>
        </table>
      </div>
    </div>
    <div class="repayment-tips">
      如有疑问请联系客服<br />
      客服热线：400-010-0008<br />
      服务时间：周一到周五 9:00-19:00<br />
    </div>
    <withdraw-mao v-if="showMao" source="repayment" status="8" :point="10405"/>
    <div v-if="buttonStatus" class="footer">
      <nd-button
        class="btn"
        @click="openSelectPopup"
        :disabled="buttonStatus.disabled"
        :showLoadingIcon="false"
      >{{ buttonStatus.text }}</nd-button>
    </div>
    <select-expense
      ref="selectPopup"
      :scheduleList="scheduleList"
      :loanPlatform="loanPlatform"
      :productCd="productCd"
      :fundCode="fundCode"
      :billNo="billNo"
      :canOffLineRepay="canOffLineRepay"
      :canOnlyRepayAll="canOnlyRepayAll"
      :termNo="termNo"
      :canConsultRepay="canConsultRepay"
    ></select-expense>
  </div>
</template>
<script>
import SelectExpense from './components/select-expense'
import { mapActions } from 'vuex'
import { getKey, judgeClientSystem } from '../../assets/utils'
import WithdrawMao from '@/components/withdraw-mao/index.vue'
import { jsBridge, hasNativeMethod } from '@/assets/jsBridge'

export default {
  name: 'repayment-detail',
  customReadyNotify: true,
  components: { SelectExpense, WithdrawMao },

  data () {
    return {
      billNo: this.$route.query.repayBillNo,
      detail: {
        rightRepayStatus: '',
        lendingDate: '',
        schdLoanServFee: '',
        terms: []
      },
      totalRepaymentAmount: 5000,
      creditStartTime: Date.now(),
      loanPlatform: this.$route.query.loanPlatform,
      agreementUrl: '',
      fundCode: 'WUJIE',
      productCd: this.$route.query.productCd,
      scheduleList: [],
      onLineRepayInProcess: false, // 当前订单是否在线上还款中（true 线上还款中）
      offLineRepayInProcess: false, // 当前订单是否在处于线上还款中（true 线下还款中）
      dueDate: '',
      canRepayDate: '',
      termNo: 0,
      canOffLineRepay: false,
      canOnlyRepayAll: false,
      from: this.$route.query.from === 'true',
      consultRepayInProcess: false, // 此订单是否在协商还款受理中
      canConsultRepay: false, // 是否是协商还款订单
      showMao: false // 是否展示猫
    }
  },

  async created () {
    await this.getOrderDetail()
    this.$bus.$emit('ready')
  },

  filters: {
    status (value) {
      const mapping = {
        U: '未支付',
        S: '已支付',
        P: '支付中',
        C: '已关闭',
        O: '已超期',
        R: '退款中'
      }
      return mapping[value]
    },

    platform (value) {
      const platform = getKey('platform')
      const result = platform.find(item => item.loanPlatform === value)
      if (result) {
        return result.loanPlatformName
      }
      return platform['TMD'] && platform['TMD'].loanPlatformName
    }
  },

  computed: {
    buttonStatus () {
      switch (this.detail.rightRepayStatus) {
        case 'P': // 支付中
          return { text: '支付受理中', disabled: true }
        case 'U': // 未支付
          return { text: '去支付' }
        case 'S': // 已支付
          return { text: '已支付', disabled: true }
        case 'R': // 退款中
          return { text: '退款中', disabled: true } 
        case 'O': // 已超期
          return { text: '去支付', disabled: false } 
        case 'C': // 已关闭
        default:
          return null
      }
    }
  },

  methods: {
    ...mapActions('order', ['queryExpenseDetailX']),

    goRelateProtocol () {
      this.$report({
        id: 10029,
        args: {
          position: this.loanPlatform
        }
      })
      const params = {
        loanPlatform: this.loanPlatform,
        orderId: this.$route.query.orderId,
        fundCode: this.fundCode
      }
      this.$router.push({ path: '/protocol', query: params })
    },

    openSelectPopup () {
      if (this.buttonStatus.loading) {
        return
      }
      this.$report({
        id: 10028,
        args: {
          position: this.loanPlatform
        }
      })
      this.$refs.selectPopup.open()
    },

    async getOrderDetail () {
      const response = await this.queryExpenseDetailX({
        billNo: this.billNo
      })
      // const response = {
      //   success: true,
      //   data: {
      //     billNo: '123456789',
      //     rightRepayStatus: 'S',
      //     lendingDate: 1658937600000,
      //     schdLoanServFee: 450.3,
      //     terms: [{
      //       termId: 'temId1',
      //       termNo: 1,
      //       pmtDueDate: 1658937600000,
      //       schdLoanServFee: 150.1,
      //       rightRepayStatus: 'S'
      //     }, {
      //       termId: 'temId2',
      //       termNo: 2,
      //       pmtDueDate: 1658937600000,
      //       schdLoanServFee: 150.1,
      //       rightRepayStatus: 'P'
      //     }, {
      //       termId: 'temId23',
      //       termNo: 3,
      //       pmtDueDate: 1658937600000,
      //       schdLoanServFee: 150.1,
      //       rightRepayStatus: 'U'
      //     }]
      //   }
      // }
      if (response.success) {
        this.detail = response.data
        this.scheduleList = response.data.terms
      }
    },
    hanldeBack () {
      if (hasNativeMethod('exit') && judgeClientSystem() !== 'IOS') {
        jsBridge('exit')
      } else {
        this.$router.go(-1)
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.page.repayment-detail {
    background-color: #fafafa;
    padding-bottom: 210px;

    .repayment-info {
        margin-top: 20px;

        .repayment-info-item {
            padding: 0 30px;
            border-bottom: 1px solid @iuc;

            .nd-cell-header {
                padding: 0;
            }

            .text {
                font-size: 30px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
            }
        }
    }

    .repayment-schedule {
        padding: 0 30px;

        .cell-title {
            font-size: 32px;
            height: 50px;
            line-height: 50px;
            margin-top: 40px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;

            em {
                font-size: 26px;
                font-style: normal;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: @fc3;
            }
        }

        .schedule-list {
            margin-top: 22px;
            padding-bottom: 20px;
            background-color: #ffffff;

            table {
                width: 100%;
                border-spacing: 0px;

                .table-header {
                    th {
                        font-size: 27px;
                        height: 50px;
                        line-height: 50px;
                        padding-top: 23px;
                        padding-bottom: 7px;
                        border-bottom: 1px solid @iuc;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                    }
                }

                .table-row {
                    td {
                        height: 50px;
                        line-height: 50px;
                        font-size: 22px;
                        padding-top: 10px;
                        text-align: center;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                    }

                    & + .table-row {
                        td {
                            padding-top: 2px;
                        }
                    }

                    &.s {
                        color: @fc3;
                    }

                    &.o {
                        color: @fc-error;
                    }

                    &.p {
                        color: #4b94f0;

                        td {
                            background-color: #ecf8ff;
                        }
                    }

                    &.r {
                        color: #f1591d;
                    }

                    &.now {
                        color: #4b94f0;

                        td {
                            background-color: #ecf8ff;
                        }

                        &.r {
                            color: #f1591d;

                            td {
                                background-color: #fffdf7;
                            }
                        }

                        &.s {
                            color: @fc3;

                            td {
                                background-color: #ffffff;
                            }
                        }
                        &.o {
                            color: @fc-error;

                            td {
                                background-color: #fff7f7;
                            }
                        }
                    }
                }
            }
        }
    }
    .repayment-tips{
      text-align: center;
      color: #BBBBBB;
      font-size: 24px;
      line-height: 34px;
      position: fixed;
      bottom: 225px;
      left: 50%;
      transform: translateX(-50%);
    }

    .footer {
        width: 750px;
        margin-left: -375px;
        height: 180px;
        background-color: #fff;
        position: fixed;
        bottom: 0;
        left: 50%;

        .btn {
            margin: 0 auto;
            margin-top: 28px;
        }
    }
}
</style>
